import React, { Component } from "react";
import "./css/homeMobile.css";
import { Link } from "react-router-dom";

import imageInterior from "./scr/mobile-asset1.png";
import imageExterior from "./scr/mobile-asset2.png";
import button from "./scr/buttons.png";

export default class homeMobile extends Component {
  render() {
    return (
      <div className="home-mobile-main">
        <div className="home-mobile-container">
          <img
            className="home-mobile-image"
            src={imageExterior}
            alt="imageBackground"
          />
        </div>
        <Link to="/interior">
          <div className="home-mobile-container">
            <div className="home-mobile-container-button">
              <img
                className="home-mobile-button"
                src={button}
                alt="buttonBackground"
              />
              <div className="home-mobile-button-text">พื้นที่ภายนอก</div>
            </div>
          </div>
          <div className="home-mobile-container" style={{ top: "50%" }}>
            <img
              className="home-mobile-image"
              src={imageInterior}
              alt="imageBackground"
            />
          </div>
          <div className="home-mobile-container" style={{ top: "50%" }}>
            <div className="home-mobile-container-button">
              <img
                className="home-mobile-button"
                src={button}
                alt="buttonBackground"
              />
              <div className="home-mobile-button-text">พื้นที่ต่อเติม</div>
            </div>
          </div>
        </Link>
      </div>
    );
  }
}
